import React from 'react';
import {ListItem, List, Card, CardText, CardContent} from "@chatui/core";
import './menu.css'
function Menu(props) {
    // console.log(props.items)
    const onItemClick = (item) => {
        if (props.onItemClick) {
            props.onItemClick(item);
        }
    };
    return (
        <div>
            <Card className={"menu-card"}>
                <CardText>
                    {props.title}
                </CardText>
                <CardContent>

                <List className={"menu"} variant="buttons">
                    {props.items.map((item, index)=>{
                        if (item.disable==="true") {
                            return null;
                        }
                        return (
                            <ListItem
                                className={"my-list-item"}
                                key={item.value || item.label || index}
                                onClick={()=>onItemClick(item)}
                                content={item.label}
                                as={"button"}
                                ellipsis={true}
                            ></ListItem>
                        );
                    })}
                </List>
                </CardContent>
            </Card>
        </div>
    );
}

export default Menu;